import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { pricesFromApi, ProductPrices, ProductPricing, productPricingToApiCurrencyMap } from './product-pricing';
import { PricingApiService, UpsertRetailPricingRequest } from '@vendasta/billing';
import { Frequency, frequencyToApi } from './frequency';
import { HttpResponse } from '@angular/common/http';

export class RetailPricingForSubscriptionId {
  subscriptionId: string;

  constructor(subscriptionId: string) {
    this.subscriptionId = subscriptionId;
  }
}

export class RetailPricingForCustomerId {
  customerId: string;

  constructor(customerId: string) {
    this.customerId = customerId;
  }
}

export class RetailPricingForGroupId {
  groupId: string;

  constructor(groupId: string) {
    this.groupId = groupId;
  }
}

@Injectable({ providedIn: 'root' })
export class RetailPricingService {
  constructor(private pricingApi: PricingApiService) {}

  getMultiRetailPrices(merchantId: string, skus: string[], groupId?: string): Observable<ProductPrices[]> {
    const requestGroupId: string = groupId || '';
    return this.pricingApi
      .getMultiRetail({ merchantId, skus, groupId: requestGroupId })
      .pipe(map((r) => pricesFromApi(r.prices)));
  }

  upsertPricing(
    merchantId: string,
    sku: string,
    frequency: Frequency,
    pricing: ProductPricing,
    identifier: RetailPricingForSubscriptionId | RetailPricingForCustomerId | RetailPricingForGroupId,
  ): Observable<HttpResponse<null>> {
    const req = new UpsertRetailPricingRequest({
      merchantId,
      sku,
      frequency: frequencyToApi(frequency),
      pricing: productPricingToApiCurrencyMap(pricing),
    });
    if (identifier instanceof RetailPricingForSubscriptionId) {
      req.subscriptionId = identifier.subscriptionId;
    } else if (identifier instanceof RetailPricingForCustomerId) {
      req.customerId = identifier.customerId;
    } else if (identifier instanceof RetailPricingForGroupId) {
      req.groupId = identifier.groupId;
    }
    return this.pricingApi.upsertRetail(req);
  }
}
